export const theme = {
    backgrounds: [
        '1_green',
        '2_blue',
        '3_red',
        '4_orange',

        '11_poppies',
        '12_green_field',
        '13_waterfall',
        '14_beach',
        '15_turquoise_skies',
        '20_wood',
        '30_kittens',
        '31_mountains',
        '33_winter_night',
        '34_christmas_tree',
        '5_olive',
        '6_turquoise',
        '7_burgundy',
        '8_dark_purple',

        // '21_peony',
        // '22_lonely_mountain',
        // '23_five_cats',
        // '24_road',
        // '25_new_york',
        // '26_blossom',
        // '27_clouds',
        // '28_mountain_lake',
        // '32_painted_wall',
        // '35_winter_house',
    ],
    backs: [
        '1_blue',
        '6_orange',
        '3_red',

        '71_classic_blue',
        '72_classic_purple',
        '73_classic_red',
        '75_panda_leaves',
        '76_palace',
        '27_owl',
        '15_island',
        '53_cartoon_hat_cat',
        '45_astrology',
        '66_spider',
        '22_sakura',
        '7_ginger_kitten',
        '11_cat_glasses',
        '59_golden_crown',
        '44_chinese_wall',
        '46_sky',
        '4_red_pattern',
        '39_palace',
        '74_panda',
        '24_butterfly',
        '56_porsche',
        '35_pagoda',
        '2_blue_dark',
        '51_retro_car',
        '14_white_puppy',
        '41_white_dome',
        '10_cat_crown',
        '64_snowflakes',
        '62_gift',
        '63_winter_dog',
        '65_golden_bird',
        '25_ladybug',
        '30_bamboo_bear',
        '67_heart_flowers',
        '68_heart_cat',
        '70_heart_dog',
        '69_heart_glasses',
    ],
    fronts: [
        '13_classic',
        '11_white_large',
        '1_white',
        '2_ivory',
        '3_medieval',
        '12_classic_large',
        '4_gothic',
        '5_cats',
        '6_dogs',
        '7_elegant',
        '8_neon',
        '9_retro',
        '10_cartoonish',
    ],
    buttonBackground: 0x1f1f1f,
    uiBackground: 0x1f1f1f,
    designBorder: 'FFFFFF',
    chosenDesignBorder: '#5CBD59',
    gameBackground: 0xe8e5de,
    gamePlaceholder: 0xd7d2c6,
    glowPlaceholder: 0xeae5d9,
};
